
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { avatars, avatars_active_status } from '../../index.const';

export default class LoginController {
    constructor($rootScope, $log, $state, Session, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Session = Session;
        this.Dialog = Dialog;

        this.avatars = avatars;
        this.avatars_active_status = avatars_active_status;
        
        this.user = {
            name: null,
            avatar: 0
        }

        this.state = {
            step: 1,
            isCreditVisible: false
        }
    }

    $onInit(){

        let data = this.Session.get();
        
        if (!_.isEmpty(data)){
            this.$state.go("main");
        }
    }

    compileAvatar(index, avatar){
        return this.user.avatar === index ? this.$rootScope.$avatars.actived[this.user.avatar] : avatar
    }

    submit(form){
        if(form.$invalid){
            return false;
        }

        
        if(this.user.name === null || this.user.name === undefined || this.user.name === ""){
            switch(this.user.avatar){
                case 0:
                this.user.name ='Pedro';
                break;
                case 1:
                this.user.name ='Ana';
                break;
                case 2:
                this.user.name ='Lucas';
                break;
                case 3:
                this.user.name ='Maria';
                break;

            }
        }
        
        this.Session.create(this.user);

        this.Dialog.showInterventionalFormsModal(this.showInterventionalFormsModalSuccess.bind(this));


    }
    
    showInterventionalFormsModalSuccess(){
        let totalCollectedParts = 2;
    
        this.Dialog
            .showInterventionalTrophiesModal(
                totalCollectedParts, 
                this.showInterventionalTrophiesModalSuccess.bind(this));
    }
    
    showInterventionalTrophiesModalSuccess(){
        this.Dialog.showIntroModal(this.showIntroModalSucess.bind(this));
    }
    showIntroModalSucess(){
        this.Dialog.showIntroBookModal(() => {
            this.$state.go("main");
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js